import { gql } from '@apollo/client';

export default gql`
    query preferencesQuery($userId: Int!, $producerId: Int!) {
        userPreferenceByUserId(userId: $userId) {
        userId
        preference
        }
        producerPreferenceByProducerId(producerId: $producerId) {
        producerId
        preference
        }
    }
`
